import { Navigate, Outlet } from "react-router-dom";
import useAuth from "../hooks/useAuth";

const RequireCredit = () => {
  const { auth } = useAuth();

  return !auth?.stop_credit ? <Outlet /> : <Navigate to="/account" replace />
}

export default RequireCredit;